import { render, staticRenderFns } from "./novelties.vue?vue&type=template&id=0cdac1bc&scoped=true"
import script from "./novelties.vue?vue&type=script&lang=js"
export * from "./novelties.vue?vue&type=script&lang=js"
import style0 from "./novelties.vue?vue&type=style&index=0&id=0cdac1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdac1bc",
  null
  
)

export default component.exports